import { AxiosError } from 'axios';
import instance from '../config/axios';

export const markNotificationAsRead = async (
  token: string,
  notificationIds: Array<string>,
) => {
  try {
    const response = await instance.put(
      '/api/v1/patient/notifications/update',
      { notificationIds },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (err) {
    console.error(err);
    return (err as AxiosError).response?.status as number;
  }
};
